import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, pyrotchBaseUrl } from '../axios/AxiosInstance';

export interface DoughnutChartData {
    notStartedMilestones: number;
    waitingForApprovalMilestones: number;
    completedMilestones: number;
    incompleteMilestones: number;
    delayedMilestones: number;
    onTimeMilestones: number;
  }

export const ChartApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + 'v1/', // Base URL
  }),
  reducerPath: 'chartApi',
  tagTypes: ['Milestone'],
  endpoints: (build) => ({
    getDoughnutChartData: build.query<DoughnutChartData, number>({
        query: (projectId) => {
          return {
            url: `project/${projectId}/project-overview`,
            method: "GET",
          };
        },
        providesTags: ['Milestone'],
      }),
  }),
});

export const { useLazyGetDoughnutChartDataQuery} = ChartApi;
